import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustMarquee } from "@/components/landing/TrustMarquee";
import { WhyUs } from "@/components/landing/WhyUs";
import { Services } from "@/components/landing/Services";
import { Process } from "@/components/landing/Process";
import { Tools } from "@/components/landing/Tools";
import { SuccessStories } from "@/components/landing/SuccessStories";
import { Testimonials } from "@/components/landing/Testimonials";
import { Industries } from "@/components/landing/Industries";
import { FAQ } from "@/components/landing/FAQ";
import { CtaBand } from "@/components/landing/CtaBand";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FloatingActions } from "@/components/landing/FloatingActions";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <TrustMarquee />
        <WhyUs />
        <Services />
        <Process />
        <Tools />
        <SuccessStories />
        <Testimonials />
        <Industries />
        <FAQ />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
